<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">GOSSIP</span>
          <small class="d-block">DIRECTORY</small>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link " routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/platforms" (click)="isNavOpen = false">Platforms</a></li>
          <li class="nav-item">
            <a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Your Card</a>
          </li>
          <li class="nav-item"><a class="nav-link active" routerLink="/hardship" (click)="isNavOpen = false">Harships Incentives</a></li>
        </ul>
      </div>
      <div class="d-none d-md-flex align-items-center gap-2">
        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">LOGIN</a>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
        </a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section class="hs-hero">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <span class="hs-eyebrow">FOR US. BY US. POWERED BY UMYO.</span>
        <h1 class="hs-hero-title">
          UMYO GOSSIP<br>
          <span class="text-pink">HARDSHIP INCENTIVES.</span>
        </h1>
        <p class="hs-hero-subtitle">
          UMYO GOSSIP is about more than connecting people online. We are
          building a digital ecosystem designed to create opportunities,
          strengthen businesses, connect families, and provide meaningful
          assistance to participating members of the UMYO GOSSIP community.
          Dare to be different.
        </p>
        <p class="hs-hero-subtitle">
          As membership participation and ecosystem revenue grow, up to
          <span class="text-pink">20%</span> will be allocated toward
          community hardship incentives and assistance programs.
        </p>
        <div class="hs-hero-tags">
          <span>REGISTER</span><span class="hs-dot">•</span>
          <span>PARTICIPATE</span><span class="hs-dot">•</span>
          <span>CONNECT</span><span class="hs-dot">•</span>
          <span>GROW</span>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="hs-hero-art">
          <img src="assets/images/hardship-hero.png" alt="Hands holding a family, supported by the community">
        </div>
      </div>
    </div>

    <!-- PLEDGE BANNER -->
    <div class="hs-pledge">
      <div class="hs-pledge-icon">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </div>

      <div class="hs-pledge-stat">
        <span>WE PLEDGE UP TO</span>
        <h2>20%</h2>
        <span>OF REVENUE</span>
      </div>

      <div class="hs-pledge-divider"></div>

      <p class="hs-pledge-text">
        WHEN OUR COMMUNITY GROWS, OUR ABILITY TO HELP GROWS. Together, we
        <span class="text-pink">uplift</span>,
        <span class="text-pink">empower</span>, and
        <span class="text-pink">strengthen</span> the communities we serve.
      </p>
    </div>

    <!-- REGISTRATION BUTTONS -->
    <div class="hs-actions">
      <a href="https://forms.gle/oTDHyWQKeoh5Difq5" target="_blank" rel="noopener" class="btn btn-pink hs-action-btn">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 21h18"/><path d="M5 21V7l8-4 8 4v14"/><path d="M9 21v-6h6v6"/><path d="M9 9h.01M15 9h.01M9 13h.01M15 13h.01"/>
        </svg>
        UMYO BUSINESS REGISTRATION – TO GIVE AWAY
      </a>
      <a href="https://forms.gle/YvqFZ7wMhG676d7J6" target="_blank" rel="noopener" class="btn btn-outline-pink hs-action-btn">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
        UMYO GOSSIP MEMBERS INCENTIVE REGISTRATION
      </a>
    </div>
  </div>
</section>

<!-- ============ HARDSHIP INCENTIVES GRID ============ -->
<section class="hs-incentives-section">
  <div class="container">
    <h2 class="hs-section-title">
      <span class="hs-rule"></span>
      REAL SUPPORT FOR REAL LIFE
      <span class="hs-rule"></span>
    </h2>

    <p class="hs-incentives-intro">
      Sometimes a little help can make a big difference. From groceries and
      gasoline to electricity, transportation, housing, child care, family
      needs, health-related emergencies, and unexpected circumstances, our
      goal is to create opportunities for eligible participating members to
      receive assistance when resources are available.
    </p>

    <div class="hs-grid">

      <div class="hs-card" *ngFor="let item of incentives">

        <div class="hs-card-top">

          <div class="hs-card-icon"> <div class="icon" [innerHTML]="safeSvg(item.icon)"> </div> </div>

          <h4>{{ item.title }}</h4>

          <p>{{ item.description }}</p>

          <span class="hs-amount">
            {{ item.amount }}
          </span>

        </div>

        <div class="hs-card-photo"> <div class="hs-card-illustration" [innerHTML]="safeSvg(item.illustration)"> </div> </div>

      </div>

    </div>
  </div>
</section>

<!-- ============ HOW IT WORKS + WHEN WE GROW ============ -->
<section class="hs-how-section">
  <div class="container">
    <div class="hs-how-row">

      <div class="hs-how-card">
        <h3 class="hs-how-title">
          <span class="hs-rule-short"></span>
          HOW IT WORKS
          <span class="hs-rule-short"></span>
        </h3>

        <div class="hs-steps">
          <ng-container *ngFor="let step of steps; let last = last">
            <div class="hs-step">
              <div class="hs-step-icon"> <div class="icon" [innerHTML]="safeSvg(step.icon)"> </div> </div>
              <h5>{{ step.number }}. {{ step.title }}</h5>
              <p>{{ step.description }}</p>
            </div>
            <div class="hs-step-arrow" *ngIf="!last">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
              </svg>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="hs-grow-card">
        <div class="hs-grow-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/>
          </svg>
        </div>
        <h4>WHEN WE GROW,<br><span class="text-pink">WE GIVE.</span></h4>
        <p>Every registration helps us do more for those who need it most.</p>
      </div>

    </div>
  </div>
</section>

<!-- ============ UP TO 20% BACK ============ -->
<section class="hs-back-section">
  <div class="container">
    <h2 class="hs-section-title">
      <span class="hs-rule"></span>
      UP TO 20% BACK.
      <span class="hs-rule"></span>
    </h2>
    <p class="hs-back-lead">
      OUR COMMUNITY HELPS BUILD THE ECOSYSTEM.<br>
      <span class="text-pink">THE ECOSYSTEM HELPS SUPPORT OUR COMMUNITY.</span>
    </p>
    <p class="hs-back-text">
      We are building technology with a larger purpose. Our goal is to
      create an ecosystem where community participation can help generate
      resources that support our people, strengthen businesses, create
      opportunities, and make a real difference in everyday lives.
    </p>
    <ul class="hs-back-list">
      <li>OUR MEMBERS BUILD THE COMMUNITY.</li>
      <li>OUR BUSINESSES HELP POWER THE ECONOMY.</li>
      <li>OUR PARTICIPATION HELPS CREATE VALUE.</li>
      <li>OUR GROWTH HELPS CREATE MORE OPPORTUNITIES TO GIVE BACK.</li>
    </ul>
  </div>
</section>

<!-- ============ MORE WE GROW, MORE IMPACT ============ -->
<section class="hs-growth-section">
  <div class="container">
    <h2 class="hs-section-title">
      <span class="hs-rule"></span>
      THE MORE WE GROW, THE MORE IMPACT WE CAN CREATE
      <span class="hs-rule"></span>
    </h2>

    <div class="hs-growth-grid">
      <div class="hs-growth-card">
        <h5>MORE MEMBERS.</h5>
        <p>More people connected within our digital community.</p>
      </div>
      <div class="hs-growth-card">
        <h5>MORE BUSINESSES.</h5>
        <p>More opportunities to support businesses and circulate economic activity.</p>
      </div>
      <div class="hs-growth-card">
        <h5>MORE PARTICIPATION.</h5>
        <p>A stronger and more engaged ecosystem.</p>
      </div>
      <div class="hs-growth-card">
        <h5>MORE IMPACT.</h5>
        <p>Greater potential to create programs and resources that benefit our community.</p>
      </div>
    </div>

    <p class="hs-growth-tagline">CONNECT. SUPPORT. GROW. GIVE BACK.</p>
  </div>
</section>

<!-- ============ BUILT FOR OUR COMMUNITY ============ -->
<section class="hs-built-section">
  <div class="container">
    <div class="hs-built-card">
      <h3>BUILT FOR OUR COMMUNITY.</h3>
      <p>
        This is not simply about creating another website or directory. We
        are building a digital ecosystem that connects people, businesses,
        creators, professionals, organizations, technology, resources, and
        opportunities within one growing community.
      </p>
      <p class="hs-built-emphasis text-pink">FOR US. BY US.</p>
      <p>When our community participates, our community becomes stronger.</p>
    </div>
  </div>
</section>

<!-- ============ IMPORTANT PROGRAM INFORMATION ============ -->
<section class="hs-disclaimer-section">
  <div class="container">
    <div class="hs-disclaimer-card">
      <h5>IMPORTANT PROGRAM INFORMATION</h5>
      <p>Hardship incentives are not guaranteed cash payments or guaranteed member benefits.</p>
      <p>
        Programs are subject to eligibility requirements, available funding,
        membership participation, program rules, verification requirements,
        geographic availability, and applicable laws and regulations.
      </p>
      <p>
        Amounts displayed represent maximum potential assistance amounts for
        qualifying programs. Registration or membership does not guarantee
        approval or receipt of assistance.
      </p>
      <p>
        Program categories, amounts, eligibility requirements, application
        periods, and availability may change as the ecosystem develops and
        grows.
      </p>
      <a href="#" class="hs-disclaimer-link">VIEW ELIGIBILITY &amp; PROGRAM DETAILS</a>
    </div>
  </div>
</section>

<!-- ============ BOTTOM CTA BAR ============ -->
<section class="hs-cta-section">
  <div class="container">
    <p class="hs-cta-lead">
      YOUR MEMBERSHIP HELPS BUILD THE ECOSYSTEM. Every registration helps
      strengthen the UMYO Gossip digital ecosystem, create opportunities,
      support businesses, expand technology, and increase our potential to
      make a meaningful impact throughout our community.
    </p>

    <div class="hs-cta-bar">
      <div class="hs-cta-left">
        <div class="hs-cta-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <div>
          <h4>THIS IS BIGGER THAN A DIRECTORY.</h4>
          <p class="text-pink mb-0">WE ARE BUILDING TECHNOLOGY WITH PURPOSE. JOIN TODAY. CONNECT TODAY. GROW WITH US.</p>
        </div>
      </div>

      <a href="/?authTab=register#register" class="btn btn-pink">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/><path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1"/><path d="M19 8v6M22 11h-6"/>
        </svg>
        REGISTER NOW
      </a>
    </div>
  </div>
</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">GOSSIP</span></div>
        </div>
        <small class="d-block pkg-footer-muted">FOR US. BY US.<br>POWERED BY UMYO.</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">QUICK LINKS</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/platforms">Platforms</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">RESOURCES</h6>
        <ul class="pkg-footer-links">
          <li><a href="#">Hardship Program Details</a></li>
          <li><a href="#">Eligibility</a></li>
          <li><a href="#">FAQs</a></li>
          <li><a href="#">Help Center</a></li>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">LET'S CONNECT</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>© 2026 UMYO Gossip Directory. All Rights Reserved.</small>
    </div>
  </div>
</footer>